import React, { useState, useMemo, useCallback, useEffect } from "react"
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { CurrentCardStatus, CardActionType } from '../types'
import { FreezeActionType } from '../components/FreezeModal/index.type'
import { useElectronicCardInfo } from "@/hooks"
import { APIWeb } from '@/api/index'
import { Toast } from 'react-vant'
import FreezeModal from '../components/FreezeModal'
import CardSwiper from '../components/CardSwiper'
import CardActions from '../components/CardActions'
import TransactionRecords from '../components/TransactionRecords'

export default React.memo(function ElectronicCard() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [showFreezeModal, setShowFreezeModal] = useState(false)
  const { cardInfo, actions: cardActions } = useElectronicCardInfo()
  const [freezeActionType, setFreezeActionType] = useState<FreezeActionType>(FreezeActionType.Freeze)
  const [currentCardId, setCurrentCardId] = useState<number>(0)

  // 电子卡列表数据（后续从接口获取）
  const cards = useMemo<CardInfoResponse[]>(() => {
    if (!cardInfo?.id) return []
    // 目前只有一张卡，后续会是卡片列表
    return [cardInfo]
  }, [cardInfo])

  // 初始化当前卡片ID
  useEffect(() => {
    if (cardInfo?.id && !currentCardId) {
      setCurrentCardId(cardInfo.id)
    }
  }, [cardInfo?.id, currentCardId])

  // 处理卡片切换
  const handleCardChange = useCallback((cardId: number, index: number) => {
    console.log('切换到电子卡:', cardId, '索引:', index)
    setCurrentCardId(cardId)
  }, [])

  const handleCardAction = useCallback(async (actionType: CardActionType) => {
    switch (actionType) {
      case CardActionType.CardInfo:
        navigate('/card/card-info')
        break
      case CardActionType.FreezeUnfreeze:
        Toast.loading(t('同步卡片状态'))
        try {
          const result = await APIWeb.syncCardStatus()
          Toast.clear()
          if (result?.status === CurrentCardStatus.Active) {
            setShowFreezeModal(true)
            setFreezeActionType(FreezeActionType.Freeze)
          } else if (result?.status === CurrentCardStatus.Frozen) {
            setShowFreezeModal(true)
            setFreezeActionType(FreezeActionType.Unfreeze)
          }
        } catch (error) {
          console.error('同步卡片状态失败:', error)
          Toast.clear()
        }
        break
      case CardActionType.LimitAdjustment:
        navigate('/card/set-limit')
        break
      case CardActionType.Management:
        Toast.info(t('即将上线'))
        break
    }
  }, [navigate, t])

  const handleFreezeActionComplete = useCallback(async () => {
    cardActions.refreshCardInfo()
  }, [cardActions])

  const handleCloseFreezeModal = useCallback(() => setShowFreezeModal(false), [])

  return (
    <div className="px-6 py-6">
      {/* 电子卡 Swiper */}
      <CardSwiper cards={cards} onCardChange={handleCardChange} getCardImage={() => `/images/card/rfpay-electronic.png`} />
      
      {/* 卡片操作按钮 */}
      <CardActions onActionClick={handleCardAction} />
      
      {/* 交易记录 */}
      <TransactionRecords cardId={currentCardId} />
      
      {/* 冻结/解冻弹窗 */}
      <FreezeModal 
        freezeActionType={freezeActionType} 
        visible={showFreezeModal} 
        onClose={handleCloseFreezeModal} 
        onFreezeAction={handleFreezeActionComplete} 
      />
    </div>
  )
})
